import React from 'react';
import './Experience.scss';
import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';
import { DiCss3, DiHtml5, DiJavascript1, DiReact, DiNodejs, DiSass, DiGit, DiMongodb, DiNpm } from 'react-icons/di';
import { SiTypescript, SiVuedotjs, SiJquery, SiGraphql, SiExpress, SiWordpress } from 'react-icons/si';
import { RiNextjsFill } from "react-icons/ri";
import * as motion from "motion/react-client"

const Experience = ({ title, company, period, description, skills, onHover, isDarkMode }) => {
  const iconSize = 20;

  const getSkillIcon = (skill) => {
    const skillIcons = {
      'CSS3': <DiCss3 color="#1973bb" size={iconSize} title="CSS3" className="skillIcon" />,
      'HTML5': <DiHtml5 color="#e34f26" size={iconSize} title="HTML5" className="skillIcon" />,
      'Javascript': <DiJavascript1 color="#f7df1e" size={iconSize} title="Javascript" className="skillIcon" />,
      'React.js': <DiReact color="#61dafb" size={iconSize} title="React.js" className="skillIcon" />,
      'Next.js': <RiNextjsFill size={iconSize} title="Next.js" className="skillIcon" />,
      'Node.js': <DiNodejs color="#339933" size={iconSize} title="Node.js" className="skillIcon" />,
      'SASS / SCSS': <DiSass color="#cc6699" size={iconSize} title="SASS / SCSS" className="skillIcon" />,
      'GIT': <DiGit color="#f05032" size={iconSize} title="Git" className="skillIcon" />,
      'MongoDB': <DiMongodb color="#47a248" size={iconSize} title="MongoDB" className="skillIcon" />,
      'NPM': <DiNpm color="#cb3837" size={iconSize} title="NPM" className="skillIcon" />,
      'Typescript': <SiTypescript color="#3178c6" size={iconSize} title="Typescript" className="skillIcon" />,
      'Vue.js': <SiVuedotjs color="#4fc08d" size={iconSize} title="Vue.js" className="skillIcon" />,
      'jQuery': <SiJquery color="#0769ad" size={iconSize} title="jQuery" className="skillIcon" />,
      'GraphQL': <SiGraphql color="#e10098" size={iconSize} title="GraphQL" className="skillIcon" />,
      'Express.js': <SiExpress color="#000000" size={iconSize} title="Express.js" className="skillIcon" />,
      'Wordpress': <SiWordpress color="#21759b" size={iconSize} title="Wordpress" className="skillIcon" />
    };

    return skillIcons[skill] || '';
  };

  const handleMouseEnter = () => {
    if (typeof onHover === 'function') {
      onHover(skills);
    }
  };

  const handleMouseLeave = () => {
    if (typeof onHover === 'function') {
      onHover([]);
    }
  };

  return (
    <motion.div 
      className="experience-card" 
      initial={{ opacity: 0, scale: 0.5 }}
      whileInView={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
      transition={{
        duration: 0.8,
        scale: { type: "spring", bounce: 0.3, duration: 0.8 },
      }}
      viewport={{ once: true, amount: 0.4 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="experience-header">
        <div className="experience-icon">
          <FaBriefcase className={isDarkMode ? 'dark' : 'light'} />
        </div>
        <div className="experience-title">
          <h3>{title}</h3>
          <h4>{company}</h4>
        </div>
      </div>
      
      <div className="experience-details">
        <div className="experience-meta">
          <span className="period">
            <FaCalendarAlt /> {period}
          </span>
        </div>
        
        <p className="experience-description">{description}</p>
        
        <div className="experience-skills">
          {skills.map((skill, index) => (
            <span key={index} className="skill-tag">
              {getSkillIcon(skill)}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Experience; 